"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadyLandingPageAfterLogin = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const next_components_icon_label_n_1 = __importDefault(require("@gerenciatd/next.components.icon-label-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const next_components_button_n_1 = __importDefault(require("@gerenciatd/next.components.button-n"));
const next_components_text_info_n_1 = __importStar(require("@gerenciatd/next.components.text-info-n"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const constants_1 = require("../../constants");
const getReadyLandingPageAfterLogin = () => {
    const isFrontApp = typeof window !== 'undefined' && window.location && window.location.pathname;
    let dest = 'https://www.movistar.es/mimovistar-cliente/publico/servicio/login?urlContenedora=https://www.movistar.es/Privada/DesafioUnico&urlDestino=';
    if (typeof window !== 'undefined' && window.location && window.location.pathname) {
        dest = `${dest}${window.location.pathname}`;
    }
    else {
        // caso por defecto
        dest = `${dest}/mimovistar-cliente/publico/acceso/privado/cclivrmisproductos`;
    }
    if (isFrontApp) {
        window.location = dest;
    }
};
exports.getReadyLandingPageAfterLogin = getReadyLandingPageAfterLogin;
const Login = (props) => {
    const { location, title, svgTitle, ariaLabel, button, subButton, linkList, addModal, segment, } = props;
    return (react_1.default.createElement("div", { className: "LoginModal" },
        react_1.default.createElement("div", { className: "HeadSection" },
            react_1.default.createElement(next_components_custom_link_1.default, { onClick: () => addModal({
                    type: 'MODAL',
                    id: '',
                }), ariaLabel: "Cerrar modal", title: "Cerrar modal", taggingInfo: {
                    componentName: 'header',
                    componentProduct: '',
                    componentContent: '',
                    componentVariation: '',
                }, className: "closeX" },
                react_1.default.createElement(next_components_icon_n_1.default, { id: "Cerrar", size: 18, layoutSize: { w: 18, h: 18 } })),
            react_1.default.createElement(next_components_icon_label_n_1.default, { id: svgTitle, iconSize: 30, iconColor: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE, className: `MovistarLogo ${segment}`, label: title, labelPosition: "bottom", labelFont: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.REGULAR, labelColor: segment === constants_1.PARTICULARES ? next_components_text_info_n_1.TEXT_INFO_COLOR.BLACK : next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE, "aria-label": ariaLabel, kind: segment === constants_1.PARTICULARES
                    ? 's'
                    : 'm', layoutSize: {
                    w: 50,
                    h: 50,
                } })),
        react_1.default.createElement("div", { className: "BodySection" },
            button && (react_1.default.createElement(next_components_button_n_1.default, { backgroundColor: "primary", onClick: exports.getReadyLandingPageAfterLogin, label: button.text, buttonWidth: "full", className: "loginButton", taggingInfo: button.taggingInfo })),
            subButton && (react_1.default.createElement(next_components_custom_link_1.default, { href: subButton.link, taggingInfo: subButton.taggingInfo, ariaLabel: subButton.text, title: subButton.text, className: "registryLink" },
                react_1.default.createElement(next_components_text_info_n_1.default, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION2, text: subButton.text, color: next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE, align: next_components_text_info_n_1.TEXT_INFO_ALIGN.CENTER }))),
            linkList && (react_1.default.createElement("div", { className: "FrequentLinksArea" }, linkList.map((sectionInfo) => {
                const { title: titleSection, links } = sectionInfo;
                return (react_1.default.createElement(react_1.Fragment, { key: titleSection },
                    react_1.default.createElement(next_components_text_info_n_1.default, { text: titleSection, display: "block", size: next_components_text_info_n_1.TEXT_INFO_SIZE.TITLE6, className: "sectionLinksTitle" }),
                    react_1.default.createElement("div", { className: "linksList" }, links &&
                        links.map((itemLink) => {
                            const { taggingInfo, link, text } = itemLink;
                            return (react_1.default.createElement(next_components_custom_link_1.default, { key: text, href: link, ariaLabel: text, title: text, className: "myfqlink", taggingInfo: taggingInfo },
                                react_1.default.createElement(next_components_icon_label_n_1.default, { id: "CheuronRight", iconColor: next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE, iconSize: 10, labelFont: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.REGULAR, label: text, labelColor: next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE, labelPosition: "left" })));
                        }))));
            }))))));
};
const mapStateToProps = (state) => ({
    segment: state.main.context.pageSegment,
});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Login);
//# sourceMappingURL=index.js.map